import { gql } from 'graphql-tag'

export const UPDATE_ACCOUNT_HOME_MODULES_MUTATION = gql`
  mutation UpdateAccountHomeModules($homeModules: [Dashboard!]!) {
    updateAccountHomeModules(homeModules: $homeModules) {
      homeModules
    }
  }
`
